import { LocalStorageKey } from '@diritto/common/utils/localStorage';
import { ModalType } from 'constants/modal';
import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { LocalStorage } from 'utils/LocalStorage';
import { ModalHandler } from 'utils/ModalHandler';

const HIDE_MODAL_TIME = 30; // 30 days

export const useShowAppInstallBottomModal = () => {
  const markHideTime = useCallback(() => {
    LocalStorage.setItem(LocalStorageKey.AppInstallBottomModalHideTime, DateTime.now().toJSDate().getTime().toString());
  }, []);

  const showAppInstallBottomModal = useCallback(() => {
    setTimeout(() => {
      ModalHandler.show(ModalType.AppInstall, {
        title: '디리토 앱에서 알림을 받아보세요.',
        description: '보고 있는 작품의 새 회차와\n좋아하는 작가님의 신작을 놓치지 마세요.',
        onClickDownload: markHideTime,
        cancelText: '웹으로 계속 이용하기',
        onCancel: markHideTime,
      });
    }, 500);
  }, [markHideTime]);

  return useCallback(() => {
    const hideTime = LocalStorage.getItem(LocalStorageKey.AppInstallBottomModalHideTime);
    if (!hideTime) {
      showAppInstallBottomModal();
      return;
    }

    if (DateTime.now().minus({ days: HIDE_MODAL_TIME }) > DateTime.fromMillis(Number(hideTime as string))) {
      showAppInstallBottomModal();
    }
  }, [showAppInstallBottomModal]);
};
